export default __webpack_public_path__ + "static/media/element_68.17bd9435.avif";